module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('wiz-layout', {
    attrs: {
      "steps": _vm.steps,
      "initial-step": _vm.step
    },
    on: {
      "close": _vm.exitWizard,
      "cancel": _vm.exitWizard
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = $$v
      },
      expression: "location"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1220f104","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wizards/Location/index.vue
// module id = 1329
// module chunks = 9